import { ApiBase } from "../apiBase";
import { ApiHexaBase } from "./ApiHexaBase";
import { EntityEvidencesStatisticsResponse, MostMonitoredNamesResponse, MostReturnedEntitiesResponse, MostSearchedNamesResponse, MostSearchedTagsResponse, StatisticsOrigin, TagsHistogramInterval, TagsHistogramResponse } from "./models/EntityStatisticsModels";

export class ApiEntityStatistics extends ApiHexaBase {
      public static statisticsBaseUrl(): string {
        return `${ApiHexaBase.baseUrl}/stats`;
      }

        public static async mostSearchedNames(
            params: {
              start_date?: string;
              end_date?: string;
              requested_results?: number;
              tags?: string[];
              origin?: StatisticsOrigin;
            }
        ): Promise<MostSearchedNamesResponse> {
          const response = await ApiBase.get(`${ApiEntityStatistics.statisticsBaseUrl()}/requests/names`, {
            start_date: params.start_date,
            end_date: params.end_date,
            requested_results: params.requested_results,
            tags: params.tags && params.tags.length > 0 ? params.tags.join(',') : undefined,
            origin: params.origin,
          });

          return response.data.data as MostSearchedNamesResponse;
        }

        public static async mostMonitoredNames(
            params: {
              start_date?: string;
              end_date?: string;
              requested_results?: number;
              tags?: string[];
            }
        ): Promise<MostMonitoredNamesResponse> {
          const response = await ApiBase.get(`${ApiEntityStatistics.statisticsBaseUrl()}/requests/monitored_names`, {
            start_date: params.start_date,
            end_date: params.end_date,
            requested_results: params.requested_results,
            tags: params.tags && params.tags.length > 0 ? params.tags.join(',') : undefined,
          });

          return response.data.data as MostMonitoredNamesResponse;
        }

        public static async mostSearchedTags(
            params: {
              start_date?: string;
              end_date?: string;
            }
        ): Promise<MostSearchedTagsResponse> {
          const response = await ApiBase.get(`${ApiEntityStatistics.statisticsBaseUrl()}/requests/tags`, {
            start_date: params.start_date,
            end_date: params.end_date,
          });

          return response.data.data as MostSearchedTagsResponse;
        }

        public static async mostReturnedEntities(
            params: {
              start_date?: string;
              end_date?: string;
              requested_results?: number;
              id?: string;
              origin?: StatisticsOrigin;
            }
        ): Promise<MostReturnedEntitiesResponse> {
          const response = await ApiBase.get(`${ApiEntityStatistics.statisticsBaseUrl()}/responses/entities`, {
            start_date: params.start_date,
            end_date: params.end_date,
            requested_results: params.requested_results,
            id: params.id,
            origin: params.origin,
          });

          return response.data.data as MostReturnedEntitiesResponse;
        }

        public static async mostRequestedEvidences(
            params: {
              start_date?: string;
              end_date?: string;
              requested_results?: number;
              id?: string;
            }
        ): Promise<EntityEvidencesStatisticsResponse> {
          const response = await ApiBase.get(`${ApiEntityStatistics.statisticsBaseUrl()}/requests/evidences`, {
            start_date: params.start_date,
            end_date: params.end_date,
            requested_results: params.requested_results,
            id: params.id,
          });

          return response.data.data as EntityEvidencesStatisticsResponse;
        }

        public static async tagsHistogram(
            params: {
              interval?: TagsHistogramInterval;
              start_date?: string;
              end_date?: string;
            }
        ): Promise<TagsHistogramResponse> {
          const response = await ApiBase.get(`${ApiEntityStatistics.statisticsBaseUrl()}/requests/tags/histogram`, {
            interval: params.interval,
            start_date: params.start_date,
            end_date: params.end_date,
          });

          return response.data.data as TagsHistogramResponse;
        }
}